import { createSlice } from '@reduxjs/toolkit'
import { IAppState } from '../../../common/context/context'

interface MantenimientoState {
  hasBeenShown: boolean
  activo: boolean
  fecha_inicio: string | null
  fecha_fin: string | null
}

export const initialState: MantenimientoState = {
  hasBeenShown: false,
  activo: false,
  fecha_inicio: null,
  fecha_fin: null,
}
export type MantenimientoStateType = typeof initialState
export const key = 'mantenimiento'

const mantenimientoSlice = createSlice({
  name: 'mantenimiento',
  initialState,
  reducers: {
    setShown(state) {
      state.hasBeenShown = true
    },
    reset(state) {
      state.hasBeenShown = false
    },
    setMantenimientoInfo(state, action) {
      const { activo, fecha_inicio, fecha_fin } = action.payload
      state.activo = activo
      state.fecha_inicio = fecha_inicio
      state.fecha_fin = fecha_fin
    },
  },
})

export const { setShown, reset, setMantenimientoInfo } =
  mantenimientoSlice.actions
export default mantenimientoSlice.reducer

export const isMantenimientoNow = (state: IAppState): boolean => {
  const { activo, fecha_inicio, fecha_fin } = state.mantenimiento
  if (!activo) return false

  const now = new Date()
  now.setHours(now.getHours() + 2)
  const start = fecha_inicio ? new Date(fecha_inicio) : null
  const end = fecha_fin ? new Date(fecha_fin) : null
  return (!start || now >= start) && (!end || now <= end)
}

export const loadMantenimiento = () => {
  return {
    type: 'MANTENIMIENTO::LOAD',
  }
}
